import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rUstBilgi, rValue } from '../../models/.catalog';

export default class AnasayfaUstBilgiApi extends ApiBase<pList, rValue<rUstBilgi>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/AnasayfaUstBilgi',
      }),
      options
    );
  }
}
